import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface NotificacionDestinatario {
    userId: string;
    nombreCompleto: string;
    roleId: string;
    roleName: string;
    estadoId: number;
    estadoNombre: string;
}

export interface Notificacion {
    id: string;
    createdAt: string;
    tipoId: number;
    tipoNombre: string;
    titulo: string;
    cuerpo: string;
    deepLink: string;
    destinatariosTipo: string;
    ambito: string;
    anioAcademicoId: string;
    nivelId: number;
    gradoId: number;
    rolId: string;
    totalDestinatarios: number;
    fechaEnvio: string;
    destinatarios?: NotificacionDestinatario[];
}

export interface PaginatedNotificaciones {
    index: number;
    size: number;
    items: Notificacion[];
}

export interface NotificacionInbox {
    id: string;
    tipoId: number;
    tipoNombre: string;
    estadoId: number;
    estadoNombre: string;
    titulo: string;
    cuerpo: string;
    deepLink: string;
    createdAt: string;
    destinatariosTipo: string;
    ambito: string;
    anioAcademicoId: string;
    nivelId: number;
    gradoId: number;
    rolId: string;
    totalDestinatarios: number;
    fechaEnvio: string;
    remitente?: {
        userId: string;
        nombreCompleto: string;
        roleId: string;
        roleName: string;
    };
}

export interface PaginatedNotificacionesInbox {
    index: number;
    size: number;
    items: NotificacionInbox[];
}

@Injectable({
    providedIn: 'root'
})
export class NotificacionesService {
    private http = inject(HttpClient);
    private apiUrl = environment.URL_API_AURORA.endsWith('/') ? environment.URL_API_AURORA : environment.URL_API_AURORA + '/';

    private mockData: Notificacion[] = [
        {
            id: '64736302-60b1-4248-8105-89df0b35575a',
            createdAt: '2026-03-05T21:13:55.123509Z',
            tipoId: 1,
            tipoNombre: 'Asistencia',
            titulo: 'test',
            cuerpo: 'test body',
            deepLink: 'aurora://notification/',
            destinatariosTipo: 'STUDENT',
            ambito: 'ESTUDIANTES',
            anioAcademicoId: '0a4ba781-90b4-4e7e-9078-3051d76c7358',
            nivelId: 0,
            gradoId: 0,
            rolId: '28391c63-9178-4ca8-99a2-c57185258e57',
            totalDestinatarios: 34,
            fechaEnvio: '2026-03-05T21:13:55.123509Z',
        }
    ];

    // We keep mock data just for getById if there is no endpoint yet, or we can remove it. But since they gave `GET api/notifications/created` we can implement it directly.
    listarEnviadas(index: number = 0, size: number = 10): Observable<{ success: number, data: PaginatedNotificaciones, message?: string }> {
        return this.http.get<any>(`${this.apiUrl}api/notifications/created?index=${index}&size=${size}`);
    }

    listarBandeja(index: number = 0, size: number = 10): Observable<{ success: number, data: PaginatedNotificacionesInbox, message?: string }> {
        return this.http.get<any>(`${this.apiUrl}api/notifications/inbox?index=${index}&size=${size}`);
    }

    marcarLeida(id: string): Observable<{ success: number, message: string, data?: any }> {
        return this.http.put<any>(`${this.apiUrl}api/notifications/${id}/read`, {});
    }

    enviar(data: any): Observable<{ success: number, message: string, data?: any }> {
        return this.http.post<any>(`${this.apiUrl}api/notifications/send`, data);
    }

    obtenerPorId(id: string): Observable<{ success: number, data?: Notificacion, message?: string }> {
        const n = this.mockData.find(x => x.id === id);
        return of({ success: n ? 1 : 0, data: n, message: n ? 'OK' : 'No encontrado' }).pipe(delay(500));
    }

    eliminar(id: string): Observable<{ success: number, message: string }> {
        this.mockData = this.mockData.filter(x => x.id !== id);
        return of({ success: 1, message: 'Notificación eliminada' }).pipe(delay(500));
    }
}
